__turbopack_context__.v({
  "Button": "SecondaryButton-module-scss-module__AciNXG__Button",
  "SecondaryButton": "SecondaryButton-module-scss-module__AciNXG__SecondaryButton",
  "SecondaryButton___danger": "SecondaryButton-module-scss-module__AciNXG__SecondaryButton___danger",
  "SecondaryButton___disabled": "SecondaryButton-module-scss-module__AciNXG__SecondaryButton___disabled",
  "Text": "SecondaryButton-module-scss-module__AciNXG__Text",
});
